<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    height="600"
    width="600"
    persistent
  >
    <v-card>
      <v-card-title>
        {{ $t("marketing.invitation.add-receivers") }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-textarea
                v-model="receivers"
                label="E-mails"
                :placeholder="$t('marketing.invitation.insert-emails')"
                :hint="$t('marketing.invitation.test-email-hint')"
                :rules="sendAll ? [] : [rules.required]"
                rows="6"
                outlined
                persistent-hint
                persistent-placeholder
              />
            </v-col>
            <v-col cols="12" sm="8" class="pt-0">
              <v-checkbox
                v-model="sendAll"
                :label="$t('marketing.invitation.send-to-all-customers')"
                hide-tails
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn @click="close" color="primary" outlined rounded>
          {{ $t("common.cancel") }}
        </v-btn>
        <BaseButton
          :loading="loadingSendEmailReceivers"
          @click="handleSubmit"
          variant="filter"
          type="submit"
        >
          {{ $t("marketing.invitation.send") }}
        </BaseButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import formRules from "../../../mixins/formRules";
import BaseButton from "@/components/forms/BaseButton.vue";

export default {
  name: "AddReceivers",
  mixins: [formRules],
  components: {
    BaseButton,
  },
  props: {
    marketingEmailId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      receivers: "",
      sendAll: false,
    };
  },
  computed: {
    ...mapGetters(["loadingSendEmailReceivers", "storeSequencial"]),
  },
  methods: {
    ...mapActions([
      "setOpenAddGuests",
      "sendEmailToReceivers",
      "showSnackbarError",
    ]),
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;

      await this.sendEmailToReceivers({
        loja: this.storeSequencial,
        idemail_marketing: this.marketingEmailId,
        envia_consumidores: this.sendAll,
        emails: this.receivers.split(/[;,]+/) || null,
      });

      this.close();
    },
    close() {
      this.$emit("close");
      this.sendAll = false;
      this.receivers = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
